import { render } from "./Geschichte.vue?vue&type=template&id=aae31a4a"
import script from "./Geschichte.vue?vue&type=script&lang=ts"
export * from "./Geschichte.vue?vue&type=script&lang=ts"

import "./Geschichte.vue?vue&type=style&index=0&id=aae31a4a&lang=scss"
script.render = render

export default script